import { render, staticRenderFns } from "./render-static.vue?vue&type=template&id=8cb74230&scoped=true&"
import script from "./render-static.vue?vue&type=script&lang=ts&"
export * from "./render-static.vue?vue&type=script&lang=ts&"
import style0 from "./render-static.vue?vue&type=style&index=0&id=8cb74230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb74230",
  null
  
)

export default component.exports